(function () {
  'use strict';

  var TAG_BG = ['yellow', 'pink', 'blue'];
  var mobileMq = window.matchMedia('(max-width: 1023px)');

  function isMobile() {
    return mobileMq.matches;
  }

  function clampStars(n) {
    var v = parseInt(n, 10);
    if (isNaN(v)) return 0;
    return Math.max(0, Math.min(5, v));
  }

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function renderStars(lit) {
    var count = clampStars(lit);
    var html = '';
    for (var i = 1; i <= 5; i++) {
      html +=
        '<span class="kbc-perf-star' +
        (i <= count ? ' kbc-perf-star--on' : '') +
        '" aria-hidden="true">' +
        (i <= count ? '★' : '☆') +
        '</span>';
    }
    return html;
  }

  function renderTags(bestForRaw) {
    if (!bestForRaw) return '';
    var parts = String(bestForRaw).split(';');
    var html = '';
    var tagIndex = 0;
    parts.forEach(function (part) {
      var label = part.trim();
      if (!label) return;
      var bg = TAG_BG[tagIndex % TAG_BG.length];
      tagIndex += 1;
      html +=
        '<span class="kbc-perf-tag kbc-perf-tag--bg-' +
        bg +
        ' kbc-perf-tag--text-dark">' +
        escapeHtml(label) +
        '</span>';
    });
    return html;
  }

  function updatePerfCell(colEl, rowKey, html, ariaLabel) {
    var cell = colEl.querySelector('[data-perf-row="' + rowKey + '"]');
    if (!cell) return;
    if (rowKey === 'best-for') {
      var tagsWrap = cell.querySelector('.kbc-perf-tags');
      if (tagsWrap) tagsWrap.innerHTML = html;
      return;
    }
    var starsWrap = cell.querySelector('.kbc-perf-stars');
    if (starsWrap) {
      starsWrap.innerHTML = html;
      if (ariaLabel) starsWrap.setAttribute('aria-label', ariaLabel);
    }
  }

  function syncColumnFromPanel(kbcRoot, column, perfTable) {
    var card = kbcRoot.querySelector('.kb-card[data-column="' + column + '"]');
    if (!card || !perfTable) return;

    var panel = card.querySelector('.kb-product-panel.is-active');
    if (!panel) {
      panel = card.querySelector('.kb-product-panel:not(.kbc-hidden)');
    }
    if (!panel) return;

    var colEl = perfTable.querySelector('[data-kbc-perf-column="' + column + '"]');
    if (!colEl) return;

    var titleEl = colEl.querySelector('[data-kbc-perf-title]');
    if (titleEl) {
      titleEl.textContent = panel.getAttribute('data-title') || '';
    }

    var gaming = panel.getAttribute('data-perf-gaming');
    var typing = panel.getAttribute('data-perf-typing');
    var portability = panel.getAttribute('data-perf-portability');
    var custom = panel.getAttribute('data-perf-custom');
    var bestFor = panel.getAttribute('data-perf-best-for') || '';

    updatePerfCell(
      colEl,
      'gaming',
      renderStars(gaming),
      clampStars(gaming) + ' out of 5 stars'
    );
    updatePerfCell(
      colEl,
      'typing',
      renderStars(typing),
      clampStars(typing) + ' out of 5 stars'
    );
    updatePerfCell(
      colEl,
      'portability',
      renderStars(portability),
      clampStars(portability) + ' out of 5 stars'
    );
    updatePerfCell(colEl, 'custom', renderStars(custom), clampStars(custom) + ' out of 5 stars');
    updatePerfCell(colEl, 'best-for', renderTags(bestFor));

    colEl.setAttribute('data-block-index', panel.getAttribute('data-block-index') || '');
  }

  function syncAllColumns(kbcRoot, perfTable) {
    for (var col = 1; col <= 3; col++) {
      syncColumnFromPanel(kbcRoot, String(col), perfTable);
    }
  }

  function ensureProductColumns(perfTable) {
    if (!perfTable) return;

    for (var col = 1; col <= 3; col++) {
      var existing = perfTable.querySelector('[data-kbc-perf-column="' + col + '"]');
      if (existing) continue;

      var colEl = document.createElement('div');
      colEl.className = 'kbc-perf-col kbc-perf-col--product kbc-perf-col--product-' + col;
      colEl.setAttribute('role', 'rowgroup');
      colEl.setAttribute('data-kbc-perf-column', String(col));
      colEl.setAttribute('data-block-index', '');

      colEl.innerHTML =
        '<div class="kbc-perf-cell kbc-perf-cell--head kbc-perf-col-title" role="columnheader">' +
        '<span data-kbc-perf-title></span>' +
        '</div>' +
        '<div class="kbc-perf-cell kbc-perf-cell--stars kbc-perf-cell--gaming" role="cell" data-perf-row="gaming">' +
        '<div class="kbc-perf-stars" aria-label="0 out of 5 stars"></div>' +
        '</div>' +
        '<div class="kbc-perf-cell kbc-perf-cell--stars" role="cell" data-perf-row="typing">' +
        '<div class="kbc-perf-stars" aria-label="0 out of 5 stars"></div>' +
        '</div>' +
        '<div class="kbc-perf-cell kbc-perf-cell--stars" role="cell" data-perf-row="portability">' +
        '<div class="kbc-perf-stars" aria-label="0 out of 5 stars"></div>' +
        '</div>' +
        '<div class="kbc-perf-cell kbc-perf-cell--stars" role="cell" data-perf-row="custom">' +
        '<div class="kbc-perf-stars" aria-label="0 out of 5 stars"></div>' +
        '</div>' +
        '<div class="kbc-perf-cell kbc-perf-cell--tags kbc-perf-cell--best-for" role="cell" data-perf-row="best-for">' +
        '<div class="kbc-perf-tags"></div>' +
        '</div>';

      perfTable.appendChild(colEl);
    }
  }

  function applyMobileColumnVisibility(kbcRoot, perfTable, displayRoot) {
    if (!perfTable) return;

    var mobile = isMobile();
    displayRoot.classList.toggle('kbc-perf-mobile-two-col', mobile);

    for (var col = 1; col <= 3; col++) {
      var colEl = perfTable.querySelector('[data-kbc-perf-column="' + col + '"]');
      if (!colEl) continue;

      if (!mobile) {
        colEl.hidden = false;
        colEl.style.display = '';
        continue;
      }

      var card = kbcRoot && kbcRoot.querySelector('.kb-card[data-column="' + col + '"]');
      var cardVisible = false;
      if (card) {
        // Use computed display so we match both inline and CSS-driven visibility.
        cardVisible = window.getComputedStyle(card).display !== 'none';
      }
      colEl.hidden = !cardVisible;
      colEl.style.display = cardVisible ? '' : 'none';
    }
  }

  function findKbcRoot() {
    return document.querySelector('.keyboard-comparison');
  }

  function refreshDisplay(displayRoot) {
    var perfTable = displayRoot._kbcPerfTable;
    var kbcRoot = displayRoot._kbcRoot || findKbcRoot();
    if (!perfTable || !kbcRoot) return;

    syncAllColumns(kbcRoot, perfTable);
    applyMobileColumnVisibility(kbcRoot, perfTable, displayRoot);
  }

  function initDisplay(displayRoot) {
    var perfTable = displayRoot.querySelector('[data-kbc-perf-table]');
    if (!perfTable) return;

    ensureProductColumns(perfTable);

    displayRoot._kbcPerfTable = perfTable;
    displayRoot._kbcRoot = findKbcRoot();
    refreshDisplay(displayRoot);

    // Layout can settle after initial JS runs (mobile chips / fonts / images).
    // Re-sync once more to ensure we start with the same 2 columns as the comparison grid.
    requestAnimationFrame(function () {
      refreshDisplay(displayRoot);
    });
    setTimeout(function () {
      refreshDisplay(displayRoot);
    }, 80);
  }

  function onProductChange(e) {
    var detail = e.detail || {};
    var column = detail.column;
    if (!column) return;

    document.querySelectorAll('[data-kbc-perf-display]').forEach(function (displayRoot) {
      var perfTable = displayRoot._kbcPerfTable;
      var kbcRoot = displayRoot._kbcRoot || findKbcRoot();
      if (!perfTable || !kbcRoot) return;
      syncColumnFromPanel(kbcRoot, String(column), perfTable);
      applyMobileColumnVisibility(kbcRoot, perfTable, displayRoot);
    });
  }

  function onLayoutChange() {
    document.querySelectorAll('[data-kbc-perf-display]').forEach(refreshDisplay);
  }

  function bindMobileMq() {
    var handler = function () {
      onLayoutChange();
    };
    if (typeof mobileMq.addEventListener === 'function') {
      mobileMq.addEventListener('change', handler);
    } else if (typeof mobileMq.addListener === 'function') {
      mobileMq.addListener(handler);
    }
  }

  function init() {
    document.querySelectorAll('[data-kbc-perf-display]').forEach(initDisplay);
    document.addEventListener('kbc:product-change', onProductChange);
    document.addEventListener('kbc:layout-change', onLayoutChange);
    bindMobileMq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Final safety: after all assets load, ensure column visibility is correct.
  window.addEventListener('load', onLayoutChange);

  document.addEventListener('shopify:section:load', function (event) {
    var displayRoot = event.target.querySelector('[data-kbc-perf-display]');
    if (displayRoot) initDisplay(displayRoot);
  });
})();
